var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"file-storage-link-button"},[_c('BaseButton',{staticClass:"no-print",attrs:{"disabled":!_vm.link,"href":_vm.url,"target":"_blank","small":"","md-icon":"cloud_upload","md-icon-position":"left","hint":_vm.hint}},[_vm._v(_vm._s(_vm.hint))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }